/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon20Solid = forwardRef('ArrowDUturnUpLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.957.434a1.25 1.25 0 0 1 1.585 1.933L6.246 4.25H11a7.25 7.25 0 0 1 0 14.5H6.5a1.25 1.25 0 1 1 0-2.5H11a4.75 4.75 0 0 0 0-9.5H6.246l2.296 1.883a1.25 1.25 0 1 1-1.585 1.934L3.136 7.433a2.5 2.5 0 0 1 0-3.866L6.957.434Z" })));
});
